export const SOFTLINE_API_CASH_REGISTER_CART = 'pointofsale-service/point-of-sale/cart';
export const SOFTLINE_API_CASH_REGISTER_CART_TRANSFORM_RECEIPT =
  'pointofsale-service/point-of-sale/transform-receipt/{{id}}';
export const SOFTLINE_API_CASH_REGISTER_CART_UPDATE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}';
export const SOFTLINE_API_CASH_REGISTER_CART_CONDITION_REASON_NECESSARY_CHECK =
  'pointofsale-service/point-of-sale/cart/{{id}}/condition-reason-necessary';
export const SOFTLINE_API_CASH_REGISTER_CART_SELL_OFF =
  'pointofsale-service/point-of-sale/sell-off';

export const SOFTLINE_API_CASH_REGISTER_CART_GET =
  'pointofsale-service/point-of-sale/cart/{{cartId}}';
export const SOFTLINE_API_CASH_REGISTER_CART_REQUIRED_INPUTS =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/required-inputs';
export const SOFTLINE_API_CASH_REGISTER_CART_GET_TEMPLATE =
  'pointofsale-service/point-of-sale/cart-template';
export const SOFTLINE_API_CASH_REGISTER_CART_DELETE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}';

export const SOFTLINE_API_CASH_REGISTER_CART_DELETE_EMPTY_CARTS =
  'pointofsale-service/point-of-sale/empty-carts';

export const SOFTLINE_API_CASH_REGISTER_CART_ITEM =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cart-items';
export const SOFTLINE_API_CASH_REGISTER_CART_ITEM_DELETE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cart-items/{{key}}';
export const SOFTLINE_API_CASH_REGISTER_CART_ITEM_UPDATE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cart-items/{{key}}';

export const SOFTLINE_API_CASH_REGISTER_ITEMS_GET =
  'pointofsale-service/point-of-sale/cart/items';
export const SOFTLINE_API_CASH_REGISTER_ITEMS_SCAN =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cart-items/scan/{{type}}/{{code}}';

export const SOFTLINE_API_CASH_REGISTER_CART_CATEGORIES =
  'pointofsale-service/point-of-sale/no-scan-categories';
export const SOFTLINE_API_CASH_REGISTER_CART_CATEGORY_PRODUCTS =
  'pointofsale-service/point-of-sale/no-scan-categories/{{categoryId}}/products';
export const SOFTLINE_API_CASH_REGISTER_CART_CATEGORY_IMAGE =
  'pointofsale-service/point-of-sale/no-scan-categories/{{categoryId}}/image';
export const SOFTLINE_API_CASH_REGISTER_CART_PRODUCT_IMAGE =
  'pointofsale-service/point-of-sale/products/{{productId}}/image';

export const SOFTLINE_API_CASH_REGISTER_CART_PAYMENT =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/payment';
export const SOFTLINE_API_CASH_REGISTER_CART_PAYMENT_CHECK =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/payment/check';
export const SOFTLINE_API_CASH_REGISTER_CART_PAYMENT_SCAN =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/payment/scan/{{labelType}}/{{code}}';

export const SOFTLINE_API_CASH_REGISTER_CART_FINALIZE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/finalize';

export const SOFTLINE_API_CASH_REGISTER_CART_DISCOUNT =
  'pointofsale-service/point-of-sale/cart/{{id}}/condition/cart-items/{{key}}';
export const SOFTLINE_API_CASH_REGISTER_CART_DISCOUNT_DELETE =
  'pointofsale-service/point-of-sale/cart/{{id}}/condition/cart-items/{{key}}/{{zuabschlag}}';
export const SOFTLINE_API_CASH_REGISTER_CART_DISCOUNT_UPDATE =
  'pointofsale-service/point-of-sale/cart/{{id}}/condition/cart-items/{{key}}';

export const SOFTLINE_API_CASH_REGISTER_CART_CREDIT_LIMIT_CHECK =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/check-credit-limit';

export const SOFTLINE_API_CASH_REGISTER_CUSTOMER_CARD_SCAN =
  'pointofsale-service/point-of-sale/customer-cards/scan/{{type}}/{{code}}';

export const SOFTLINE_API_CASH_REGISTER_DOCUMENT_TYPE_GET =
  'pointofsale-service/point-of-sale/cart/document-types';
export const SOFTLINE_API_CASH_REGISTER_DOCUMENT_PRINT =
  'pointofsale-service/point-of-sale/documents/{{documentType}}/{{cartId}}/print';
export const SOFTLINE_API_CASH_REGISTER_DOCUMENT_PRINT_LAST_RECEIPT =
  'pointofsale-service/point-of-sale/last-receipt/print';

export const SOFTLINE_API_CASH_REGISTER_DOCUMENT_FIND =
  'pointofsale-service/point-of-sale/documents/{{documentType}}';
export const SOFTLINE_API_CASH_REGISTER_DOCUMENT_SCAN =
  'v1/belege/scan/{{type}}/{{code}}';
export const SOFTLINE_API_CASH_REGISTER_DOCUMENT_GET_POSITIONS =
  'pointofsale-service/point-of-sale/documents/{{documentType}}/{{documentId}}/return-of-goods';

export const SOFTLINE_API_CASH_REGISTER_ACCOUNT_COLLECTORS =
  'pointofsale-service/point-of-sale/accounts/{{id}}/collectors';

export const SOFTLINE_API_CASH_REGISTER_VOUCHER_BALANCE =
  'pointofsale-service/point-of-sale/customer-cards/balance/{{voucher}}';

export const SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_TYPES =
  'pointofsale-service/point-of-sale/cashbook-entry/types';
export const SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cashbook-entry/{{id}}';
export const SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_CREATE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cashbook-entry';
export const SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_UNSETTLED_TRANSACTIONS =
  'pointofsale-service/point-of-sale/accounts/{{accountId}}/unsettled-transactions';

export const SOFTLINE_API_CASH_REGISTER_PAYMENT_METHODS =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/payment-methods ';

export const SOFTLINE_API_CASH_REGISTER_CART_RETURN =
  'pointofsale-service/point-of-sale/cart/return';

export const SOFTLINE_API_CASH_REGISTER_CART_RETURNABLE_ITEM_SCAN =
  'pointofsale-service/point-of-sale/returnable-items/scan/{{type}}/{{code}}';

export const SOFTLINE_API_CASH_REGISTER_OPEN_REGISTER =
  'pointofsale-service/point-of-sale/cash-register/open';

export const SOFTLINE_API_CASH_REGISTER_PRINT_LAST_RECEIPT =
  'pointofsale-service/point-of-sale/terminal/last-receipt/print';

export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CHECK =
  'pointofsaleendofday-service/point-of-sale-end-of-day/check';
export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_ENTITIES =
  'pointofsaleendofday-service/point-of-sale-end-of-day/entities';
export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CASHIER =
  'pointofsaleendofday-service/point-of-sale-end-of-day/cashier/{{cashierId}}/entities';
export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CASHIERS =
  'pointofsaleendofday-service/point-of-sale-end-of-day/cashiers';
export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_FINALIZE =
  'pointofsaleendofday-service/point-of-sale-end-of-day/finalize';
export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_FINALIZE_TERMINAL =
  'pointofsaleendofday-service/point-of-sale-end-of-day/finalize-terminal';

export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_PRINT =
  'pointofsaleendofday-service/point-of-sale-end-of-day/print';
export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_VALIDATE =
  'pointofsaleendofday-service/point-of-sale-end-of-day/validate';
export const SOFTLINE_API_CASH_REGISTER_END_OF_DAY_DELETE =
  'pointofsaleendofday-service/point-of-sale-end-of-day/{{endOfDayId}}';

export const SOFTLINE_API_CASH_REGISTER_LOCK_POS_DISPLAY =
  'pointofsale-service/point-of-sale/lock';
export const SOFTLINE_API_CASH_REGISTER_UNLOCK_POS_DISPLAY =
  'pointofsale-service/point-of-sale/unlock';

export const SOFTLINE_API_POS_CUSTOMER_INFO =
  '/customer-service/customer-service/customer/{{id}}';
